import { module } from 'angular';

import { SCALING_POLICY_MODULE } from './scalingPolicy/scalingPolicy.module';

export const SERVER_GROUP_DETAILS_MODULE = 'spinnaker.amazon.serverGroup.details';
module(SERVER_GROUP_DETAILS_MODULE, [
  SCALING_POLICY_MODULE,
  require('./securityGroup/editSecurityGroups.modal.controller.js').name,
  require('./scalingProcesses/autoScalingProcess.service.js').name,
  require('./scalingProcesses/modifyScalingProcesses.controller.js').name,
  require('./scheduledAction/editScheduledActions.modal.controller.js').name,
  require('./advancedSettings/editAsgAdvancedSettings.modal.controller.js').name,
  require('./resize/resizeServerGroup.controller.js').name,
  require('./rollback/rollbackServerGroup.controller.js').name,
]);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./app/scripts/modules/amazon/src/serverGroup/details/serverGroupDetails.module.ts